import { Component, OnInit } from '@angular/core';
import { VersionUpdateService } from '../../services/version-update.service';


@Component({
    templateUrl: './version-update-modal.component.html',
    styleUrl: './version-update-modal.component.scss'
})
export class VersionUpdateModalComponent implements OnInit {

    constructor(private versionUpdateService: VersionUpdateService) { }

    ngOnInit(): void {
    }

    onSubmit(): void {
        this.versionUpdateService.reloadPageAndRefreshCache();
    }

}
